export const LINK_TONE = {
  unprocessed: "bg-white text-slate-600 border-slate-300",
  unknown: "bg-slate-100 text-slate-700 border-slate-400",
  pending_verification: "bg-amber-100 text-amber-800 border-amber-300",
  linked_pc: "bg-orange-50 text-orange-800 border-orange-300",
  linked_bank: "bg-sky-50 text-sky-800 border-sky-300",
  linked_canonical: "bg-violet-50 text-violet-800 border-violet-300",
  duplicate: "bg-rose-50 text-rose-700 border-rose-300",
  not_project: "bg-slate-100 text-slate-500 border-slate-300",
  cancelled: "bg-slate-200 text-slate-500 border-slate-300 line-through",
  rejected: "bg-rose-100 text-rose-800 border-rose-300",
};
export const LINK_LABEL = {
  unprocessed: "Belum Diproses", unknown: "Sumber Belum Ditautkan", pending_verification: "Menunggu Verifikasi FAT",
  linked_pc: "Tertaut ke Petty Cash", linked_bank: "Tertaut ke Buku Bank", linked_canonical: "Tertaut ke Transaksi Kanonis",
  duplicate: "Duplikat", not_project: "Bukan Pengeluaran Proyek", cancelled: "Dibatalkan", rejected: "Ditolak",
};
const SUG = {
  bank: ["Sumber Bank Disarankan", "bg-sky-50 text-sky-700 border-sky-300"],
  petty_cash: ["Petty Cash Disarankan", "bg-orange-50 text-orange-700 border-orange-300"],
  unknown: ["Sumber Belum Diketahui", "bg-slate-50 text-slate-500 border-slate-300"],
};
const cls = "inline-block mt-0.5 px-1.5 py-px border text-[9px] font-semibold uppercase tracking-wider";

export function LinkBadge({ status, testid }) {
  return <span className={`${cls} ${LINK_TONE[status] || LINK_TONE.unprocessed}`} data-testid={testid}>{LINK_LABEL[status] || status}</span>;
}

export function SuggestBadge({ s, testid }) {
  const [l, c] = SUG[s?.type] || SUG.unknown;
  return (
    <span className="inline-flex flex-col" data-testid={testid}>
      <span className={`${cls} ${c}`}>{l}</span>
      {s?.type !== "unknown" && <span className="text-[10px] text-slate-500">Saran sumber: {s.label}</span>}
    </span>
  );
}
